import { 
  MessageSquare, 
  Video, 
  FileText, 
  Home, 
  DollarSign, 
  TrendingUp,
  CheckCircle2 
} from "lucide-react";
import { Button } from "@/components/ui/button";

export default function TrustSection() {
  const scrollToForm = () => {
    const formElement = document.getElementById('contact-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const preSaleServices = [
    {
      icon: MessageSquare,
      title: "Personalized Consultation",
      description: "We take time to understand your investment goals and financial objectives."
    },
    {
      icon: Video,
      title: "Virtual Tours & Analysis",
      description: "Detailed project presentations and virtual tours to help you make informed decisions."
    },
    {
      icon: FileText,
      title: "Seamless Paperwork",
      description: "We handle all bureaucratic processes on your behalf, making investment effortless."
    }
  ];

  const postSaleServices = [
    {
      icon: Home,
      title: "Property Handover Management",
      description: "We receive and inspect your property on your behalf, ensuring everything is perfect."
    },
    {
      icon: DollarSign,
      title: "Rental Management & Income Collection",
      description: "We find tenants, manage contracts, and deposit your rental income directly to your account quarterly."
    },
    {
      icon: TrendingUp,
      title: "Resale Assistance",
      description: "Expert support when you're ready to sell your investment for maximum profit."
    }
  ];

  return (
    <section className="py-20 bg-muted/30">
      <div className="container">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
              Your Trusted Partner, From First Call to Handover and Beyond
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
              We don't just sell you a property. We manage your asset and secure your peace of mind.
            </p>
          </div>

          {/* Pre-Sale Services */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                <CheckCircle2 className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-3xl font-bold text-foreground">Pre-Sale Services</h3>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              {preSaleServices.map((service, index) => {
                const Icon = service.icon;
                return (
                  <div 
                    key={index}
                    className="bg-card rounded-lg p-6 border border-border hover:shadow-lg transition-shadow"
                  >
                    <div className="w-14 h-14 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                      <Icon className="w-7 h-7 text-primary" />
                    </div>
                    <h4 className="text-xl font-bold mb-3 text-card-foreground">{service.title}</h4>
                    <p className="text-muted-foreground leading-relaxed">{service.description}</p>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Post-Sale Services */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 rounded-full bg-accent/20 flex items-center justify-center">
                <CheckCircle2 className="w-6 h-6 text-accent-foreground" />
              </div>
              <h3 className="text-3xl font-bold text-foreground">Post-Sale Services</h3>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              {postSaleServices.map((service, index) => {
                const Icon = service.icon;
                return (
                  <div 
                    key={index}
                    className="bg-card rounded-lg p-6 border border-border hover:shadow-lg transition-shadow"
                  >
                    <div className="w-14 h-14 rounded-lg bg-accent/20 flex items-center justify-center mb-4">
                      <Icon className="w-7 h-7 text-accent-foreground" />
                    </div>
                    <h4 className="text-xl font-bold mb-3 text-card-foreground">{service.title}</h4>
                    <p className="text-muted-foreground leading-relaxed">{service.description}</p>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Golden Visa Highlight */}
          <div className="bg-gradient-to-br from-accent/20 to-primary/20 rounded-2xl p-8 md:p-12 border border-accent/30">
            <div className="text-center">
              <div className="inline-block px-4 py-2 bg-accent/30 text-accent-foreground rounded-full font-semibold mb-4">
                EXCLUSIVE BENEFIT
              </div>
              <h3 className="text-3xl font-bold mb-4 text-foreground">
                10-Year UAE Golden Visa Eligibility
              </h3>
              <p className="text-lg text-muted-foreground mb-6 max-w-2xl mx-auto">
                Purchases above AED 2,000,000 qualify for the prestigious 10-year UAE Golden Visa, giving you and your family long-term residency in one of the world's most dynamic cities.
              </p>
              <Button 
                size="lg" 
                className="text-lg px-8 py-6"
                onClick={scrollToForm}
              >
                Learn More About Golden Visa
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
